import React, { useRef, useEffect} from "react"
import {_getErrorMessage} from "../../Utils/getErrorMessage"

import InputForm from "../InputForm"

import "./VerifyOtp.css"

const VerifyOtp = ({otp, error="", validateOtpError="", resendOtpCounter=0, validateOtpDisabled = false,  buttonsDisabled = false,  _handleOtpInput, _handleResendOtpClick, _handleCancelClick, _handleProceedClick, resendOtpDisabled = false, t }) => {
  const verify_otp_ref = useRef();

  useEffect(() => {
    verify_otp_ref.current.scrollIntoView({ behavior: 'smooth', block:'start' })
  },[])

  const _handleOtpChange = (e) => {
    if (e.target.value.length < 7) {
      _handleOtpInput(e);
    } else {
      e.target.value = otp;
    }
  }

  return (
    <div ref={verify_otp_ref} className="express-interest-question">
      <div className="express-interest-left-col">
        <h1 className="express-interest-question-heading">OTP</h1>
        <span className="express-interest-question-description">{t("EOI_ENTER_OTP_TEXT")}</span>
      </div>
      <div className="express-interest-right-col">
        <InputForm placeholder="Enter OTP" addClassInput={`express-interest-add-input-form${buttonsDisabled ? " disabled" : " active"}`} value={otp} error={_getErrorMessage(error)} type="text" onChange={_handleOtpChange} />
        { buttonsDisabled ? <></>
          : resendOtpCounter > 0
          ? <div className="express-interest-resend-otp-text">{t("EOI_RESEND_OTP_TEXT")} {resendOtpCounter} seconds </div>
          : <div className={`express-interest-different-id-flow-resend-otp${resendOtpDisabled ? " disabled" : ""}`} onClick={_handleResendOtpClick} disabled={resendOtpDisabled}>{t("EOI_RESEND_OTP")}</div>
        }
        {!buttonsDisabled && 
          <div className="express-interest-different-id-flow-button-flex">
            <InputForm
              addClassInput={`express-interest-modal-button-yes background-white${buttonsDisabled ? " pointer-disabled" : ""} express-interest-modal-button-padding`}
              type="button"
              value={t("EOI_CANCEL")}
              disabledValue={buttonsDisabled}
              onClick={_handleCancelClick}
            />
            <InputForm
              addClassInput={`express-interest-modal-button-yes express-interest-modal-button-padding ${validateOtpDisabled ? "express-interest-modal-button-disabled" : ""}`}
              type="button"
              value={t("EOI_PROCEED")}
              disabledValue={buttonsDisabled || validateOtpDisabled}
              onClick={_handleProceedClick}
            />
          </div>
        }
        {(validateOtpError && validateOtpError.length) && <><p className="form-element-error create-acc-get-otp-error">{_getErrorMessage(validateOtpError)}</p></>}
      </div>
    </div>
  )
} 

export default VerifyOtp;